import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { Site } from '../../sites';
import { Category } from '../../documents';
import { DocumentsBuildPart } from './documents-build-part';
import { SubjectParams } from './types';
import { OnScreenResultsBuildPart } from './on-screen-results-build-part';
import {EQueryBuildPart} from './e-query-build-part';

export class SiteBuildPart extends BaseBuildPart {
    constructor(private readonly siteHelperParams: HelperParams,
                parent: BaseBuildPart,
                site: Site) {
        super(siteHelperParams, parent, [site.study.studyUrlParameter, site.siteUrlParameter]);
    }

    public onScreenResults(tab?: string): OnScreenResultsBuildPart {
        return new OnScreenResultsBuildPart(this.siteHelperParams, this, tab);
    }

    public documents(category: Category): DocumentsBuildPart {
        return new DocumentsBuildPart(this.siteHelperParams, this, category);
    }

    public labReports(): BaseBuildPart {
        return new BaseBuildPart(this.siteHelperParams, this, ['lab-reports']);
    }

    public kitInventory(): BaseBuildPart {
        return new BaseBuildPart(this.siteHelperParams, this, ['kit-inventory']);
    }

    public eQueries(): EQueryBuildPart {
        return new EQueryBuildPart(this.siteHelperParams, this);
    }

    public subject(subject?: SubjectParams, tab?: string): BaseBuildPart {
        const paths = ['subjects'];

        if (subject) {
            const zcSubjectId = subject.zcSubjectId.toString();
            paths.push(zcSubjectId);

            if (tab) {
                paths.push(tab);
            }
        }

        return new BaseBuildPart(this.siteHelperParams, this, paths);
    }
}
